import React from "react";

import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * Hook to get team events with real-time updates
 * Returns raw events - use teamMembers prop in consuming component to look up user info
 * @param {string} teamId The team ID
 * @param {string} weekOf Week identifier (yyyy-MM-dd)
 * @returns {{events: Array, loading: boolean, error: Error|null}} Team events data
 */
export function useTeamEvents(teamId, weekOf) {
  const [events, setEvents] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (!teamId || !weekOf) {
      setEvents([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const unsubscribe = FirebaseAdapter().events.subscribeToTeamEvents(
        teamId,
        weekOf,
        (eventsData) => {
          setEvents(eventsData);
          setLoading(false);
        },
        (err) => {
          console.error("Team events subscription error:", err);
          setError(err);
          setEvents([]);
          setLoading(false);
        },
      );

      return unsubscribe;
    } catch (err) {
      console.error("Failed to subscribe to team events:", err);
      setError(err);
      setLoading(false);
    }
  }, [teamId, weekOf]);

  return { events, loading, error };
}
